// types
import { AppStoreScreensStateSchema } from "../types/selectedScreensTypes";

export const getAppStoreScreensState = (state: AppStoreScreensStateSchema) =>
  state.appStoreScreens; 